import { render, staticRenderFns } from "./editFeederbowelYear.vue?vue&type=template&id=0e983b78&scoped=true&"
import script from "./editFeederbowelYear.vue?vue&type=script&lang=js&"
export * from "./editFeederbowelYear.vue?vue&type=script&lang=js&"
import style0 from "./editFeederbowelYear.vue?vue&type=style&index=0&id=0e983b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e983b78",
  null
  
)

export default component.exports